import { useTranslation } from 'react-i18next'
import { Wizard } from '@lounge-fe/ui-kit'
import { StepLayout } from '../StepLayout'
import { StepChoiceChips } from '../StepChoiceChips'
import { StepActions } from '../StepActions'
import { useFittingRoomContext } from '../FittingRoomProvider'

export const BottomsSize = () => {
  const { t } = useTranslation()
  const { bottomsSizes } = useFittingRoomContext()

  return (
    <Wizard.Step>
      <StepLayout
        title={t('fitting_room.bottoms_size.title')}
        subtitle={t('fitting_room.bottoms_size.subtitle')}
      >
        <StepChoiceChips
          name="bottomsSize"
          options={bottomsSizes.map((size) => ({ label: size, value: size }))}
        />
        <StepActions next={false} />
      </StepLayout>
    </Wizard.Step>
  )
}
